import React, { useEffect, useState } from "react";
import { loadYaml } from "../utils/loadYaml";
import { HeroSection } from "../components/herosection";
import { BifurcatedPromo } from "../components/BifurcatedPromo";
import { FeatureGrid } from "../components/FeatureGrid";
import "./ISRSystems.css";

interface Section {
  type: string;
  id?: string;
  variant?: string;
  [key: string]: any;
}

interface SectionsData {
  sections: Section[];
}

export const ISRSystems: React.FC = () => {
  const [sections, setSections] = useState<Section[]>([]);

  useEffect(() => {
    loadYaml("/config/isr-systems.yaml").then((data: SectionsData) => {
      setSections(data?.sections || []);
    });
  }, []);

  return (
    <div className="isr-systems-page">
      {sections.map((s, idx) => {
        switch (s.type) {
          case "hero":
            if (!s.carousel || s.carousel.length === 0) return null;
            return <HeroSection key={idx} {...s} carousel={s.carousel} id={s.id} />;

          case "bifurcatedPromo":
            return (
              <BifurcatedPromo
                key={idx}
                title={s.title || ""}
                left={s.left || { title: "", description: "" }}
                right={s.right || { title: "", description: "" }}
                id={s.id}
               
              />
            );

          case "featureGrid":
            return (
              <FeatureGrid
                key={idx}
                title={s.title || ""}
                features={s.features || []}
                id={s.id}
                variant={s.variant}
              />
            );

          default:
            return null;
        }
      })}
    </div>
  );
};

export default ISRSystems;
